var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5999 3C14.1414 3 16.5788 4.00089 18.3758 5.78249C20.1729 7.56408 21.1825 9.98044 21.1825 12.5C21.1825 15.0196 20.1729 17.4359 18.3758 19.2175C16.5788 20.9991 14.1414 22 11.5999 22C9.05847 22 6.6211 20.9991 4.82401 19.2175C3.02693 17.4359 2.01733 15.0196 2.01733 12.5C2.01733 9.98044 3.02693 7.56408 4.82401 5.78249C6.6211 4.00089 9.05847 3 11.5999 3ZM11.5999 4C9.32599 4 7.14518 4.89553 5.53727 6.48959C3.92935 8.08365 3.02603 10.2457 3.02603 12.5C3.02603 14.7543 3.92935 16.9163 5.53727 18.5104C7.14518 20.1045 9.32599 21 11.5999 21C12.7259 21 13.8408 20.7801 14.881 20.353C15.9213 19.9258 16.8664 19.2997 17.6626 18.5104C18.4588 17.7211 19.0903 16.7841 19.5212 15.7528C19.9521 14.7215 20.1738 13.6162 20.1738 12.5C20.1738 10.2457 19.2705 8.08365 17.6626 6.48959C16.0547 4.89553 13.8739 4 11.5999 4ZM11.0956 7H12.1043V12.42L16.8451 15.13L16.3408 16L11.0956 13V7Z",
    fill: "black",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.cc79577b99e8838d75f21f0ff88a2522.svg";
export { ForwardRef as ReactComponent };